import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  ViewChild,
  HostListener,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ClientService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { CONSTANTS_CRM } from '@fitness-force/constants';
import {
  ClientById,
  ClientInteraction,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';

import { OverlayPanel } from 'primeng/overlaypanel';
import { PopoverModule } from 'primeng/popover';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';

import { BehaviorSubject, Observable } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';
import { CommunicationDirection } from '@fitness-force/enum';
import { ConversationLogsComponent } from '../../activity-logs/conversation-logs.component';
import { ReplyComponent } from '../../reply/reply.component';
import Statsig from 'statsig-js';

@Component({
  selector: 'client-interaction-tab',
  templateUrl: './client-interaction-tab.component.html',
  styleUrls: ['./client-interaction-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CommonModule,
    DividerModule,
    TimelineModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    TagModule,
    StyleClassModule,
    DialogModule,
    PopoverModule,
    AvatarModule,
    CheckboxModule,
    TagModule,
    DatePickerModule,
    SkeletonModule,
    StyleClassModule,
    TooltipModule,
    ConversationLogsComponent,
    ReplyComponent,
    TranslateModule
]
})
export class ClientInteractionTabComponent implements OnInit, OnDestroy {
  getAccessTenantList$: Observable<any> | any | null;
  tenantId: number = 0;
  @Input('clientId') clientId: number = 0;
  @Input('showSkeleton') showSkeleton$ = new BehaviorSubject<boolean>(true);
  @Input('showMax') showMax = 0;
  @Input('showCollapsed') showCollapsed$ = new BehaviorSubject<boolean>(false);
  @Input('interactions') Interactions$ = new BehaviorSubject<ClientInteraction[]>([]);
  @Input('clientDetails') client: ClientById = {} as ClientById;
  @Input('clickFromTab') clickfromTab = new BehaviorSubject<boolean>(false);
  @Input('height') height = "40vh";
  @Input('interactionId') interactionId: number =0;

  clientInteractions$ = new BehaviorSubject<ClientInteraction[]>([]);
  allInteractions$ = new BehaviorSubject<ClientInteraction[]>([]);
  activeTab: string = 'interaction';
  interactionDetails: {
    key: string;
    title: string;
    type: string;
    icon: string;
    status: string;
    message: string;
  }[] = [];

  getStaffList$: Observable<any> | any;
  callOutcome: any[];
  tourOutcome: any[];
  taskTypes: any = [];
  selectedTasks: any = [];
  filterForm: UntypedFormGroup = new UntypedFormGroup({});
  requestParams = new Map();
  typeFilterArray = new Map();
  interactionSinceDate: Date;
  showMoreEmail: number = 100;
  showMoreSms: number = 100;
  showMoreCall: number = 50;
  showMoreSMS: boolean = false;
  @ViewChild('staffDetails') staffDetails: OverlayPanel;
  signatures: any = [];
  tenants: any[];
  isTwoWayNotificationEnabled: boolean = false;
  lastInteraction: ClientInteraction = {} as ClientInteraction;
  showDotColor: string = 'text-red-500';

  constructor(
    private store: Store,
    private activatedRouter: ActivatedRoute,
    private clientService: ClientService,
    private fb: UntypedFormBuilder,
    public translate: TranslateService,
    public cd: ChangeDetectorRef,
    public toastMessageService: ToastMessageService,
    private timeService: TimeconversionService
  ) {
    this.signatures = {
      JVBERi0: 'application/pdf',

      R0lGODdh: 'image/gif',
      R0lGODlh: 'image/gif',
      iVBORw0KGgo: 'image/png',
      '/9j/': 'image/jpg',
    };
    this.taskTypes = ['Call', 'Sms', 'Email', 'Tour', 'Whatsapp'];
    this.interactionDetails = [
      {
        key: 'EMAIL_SENT',
        title: 'Email Sent',
        type: 'email',
        icon: ' fa fa-envelope font-light',
        status: 'outgoing',
        message: 'NEW_EMAIL_SENT',
      },
      {
        key: 'EMAIL_RECEIVED',
        title: 'Email Received',
        type: 'email',
        icon: ' fa fa-envelope font-light',
        status: 'incoming',
        message: 'NEW_EMAIL_RECEIVED',
      },
      {
        key: 'SMS_SENT',
        title: 'SMS Sent',
        type: 'sms',
        icon: 'fa fa-comments font-light',
        status: 'outgoing',
        message: 'NEW_SMS_SENT',
      },
      {
        key: 'SMS_RECEIVED',
        title: 'SMS Received',
        type: 'sms',
        icon: 'fa fa-comments font-light',
        status: 'incoming',
        message: 'SMS_RECEIVED_BY',
      },
      {
        key: 'APP_NOTIFICATION',
        title: 'App Notification',
        type: 'notification',
        icon: 'fa fa-phone',
        status: 'outgoing',
        message: 'APP_NOTIFICATION_BY',
      },
      {
        key: 'CALL_MADE',
        title: 'Call Made',
        type: 'call',
        icon: 'fa fa-phone',
        status: 'outgoing',
        message: 'CALL_MADE_BY',
      },
      {
        key: 'TOUR_SCHEDULE',
        title: 'Tour Scheduled',
        type: 'tour',
        icon: 'fa fa-map-marker-alt',
        status: 'outgoing',
        message: 'TOUR_SCHEDULE_BY',
      }
  ];
  }

  ngOnInit(): void {
    this.componentInit();
    this.isTwoWayNotificationEnabled = Statsig.checkGate("show_staff_2way_message_notifciation");
  }

  componentInit() {
    this.filterForm = this.fb.group({
      fromDate: [{ value: '', disabled: false }],
      toDate: [{ value: '', disabled: false }],
      selectedTasks: [this.selectedTasks],
      selectAll: [true],
      selectAllTask: [true],
      selectedTenant: []
    });
    this.selectedTasks = this.taskTypes;
    this.filterForm.controls.selectedTasks.setValue(this.selectedTasks);
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenants = tenant.accessed_tenant;
      this.tenantId = tenant.selected_tenant.id;
      this.filterForm.controls.selectedTenant.setValue(tenant.selected_tenant);
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
      this.getClientInteractions();
      this.translateOutComeOption();
  }

  @HostListener('window:visibilitychange', ['$event'])
  VisibilityChange(event: any): void {
    if (event.target.visibilityState.toLowerCase() == 'visible') {
      this.getClientInteractions(false);
    }
  }


  translateOutComeOption(): void {
    this.callOutcome = CONSTANTS_CRM.CALL_OUTCOME;
    this.tourOutcome = CONSTANTS_CRM.TOUR_OUTCOME;
    this.translate
      .get([
        'OUTCOME.CALLOUTCOME.NO_ANSWER_LEFT_MESSAGE',
        'OUTCOME.CALLOUTCOME.CONTACT_MADE',
        'OUTCOME.CALLOUTCOME.NOT_INTERESTED',
        'OUTCOME.CALLOUTCOME.BOOK_TOUR',
        'OUTCOME.CALLOUTCOME.SIGN_UP'
  ])
      .subscribe((translation) => {
        this.callOutcome.forEach((obj: any) => {
          switch (String(obj.shortname).toLowerCase()) {
            case 'noanswer':
              obj.name =
                translation['OUTCOME.CALLOUTCOME.NO_ANSWER_LEFT_MESSAGE'];
              break;
            case 'contactmade':
              obj.name = translation['OUTCOME.CALLOUTCOME.CONTACT_MADE'];
              break;
            case 'notintrested':
              obj.name = translation['OUTCOME.CALLOUTCOME.NOT_INTERESTED'];
              break;
            case 'booktour':
              obj.name = translation['OUTCOME.CALLOUTCOME.BOOK_TOUR'];
              break;
            case 'signup':
              obj.name = translation['OUTCOME.CALLOUTCOME.SIGN_UP'];
              break;
            default:
              break;
          }
        });
      });
  }

  getClientInteractions(showSkeleton:boolean = true) {
    if(this.clickfromTab.value && showSkeleton) this.showSkeleton$.next(true);
    this.requestParams.has("tenant_id")
    {
      this.requestParams.delete("tenant_id");
    }
    this.requestParams.set('tenant_id', { paramName: 'tenant_id', paramValue: this.filterForm.controls.selectedTenant.value.id });
    this.clientId = this.activatedRouter.snapshot?.params['clientid'] ? this.activatedRouter?.snapshot?.params['clientid'] : this.clientId;
    const params = this.typeFilterArray.size > 0 ? [...this.typeFilterArray.values(), ...this.getAllParams] : this.getAllParams;
    this.clientService.getClientInteractions(this.clientId, params).subscribe({
      next: (res: any) => {
        this.setInteractionData(res.items);
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        if(this.clickfromTab.value) this.showSkeleton$.next(false);
        this.cd.detectChanges();
      },
    });
  }


  setInteractionData(interactions:ClientInteraction[])
  {
    this.allInteractions$.next(interactions ? interactions : []);
    if(this.showMax > 0) {
      if(this.interactionId > 0) {
        let index = interactions.findIndex(i => i.interaction_id == this.interactionId);
        if(index > -1) {
          this.clientInteractions$.next(interactions.splice(index, 3));
        }
        else {
          this.clientInteractions$.next(interactions.splice(0,this.showMax));
        }
      }
      else 
        this.clientInteractions$.next(interactions.splice(0,this.showMax));
    } 
    else this.clientInteractions$.next(interactions);
    this.lastInteraction = this.clientInteractions$.value.sort((a, b) => new Date(a.log_date).getTime() - new Date(b.log_date).getTime())[this.clientInteractions$.value.length - 1];
    if(this.clickfromTab.value) this.showSkeleton$.next(false);
    if(this.clickfromTab.value) this.showSkeleton$.next(false);
    this.hasRecentIncomingWhatsApp(this.clientInteractions$.value);
    this.cd.detectChanges();
  }


  getLastInteraction() {
    return this.allInteractions$.value[this.allInteractions$.value.length - 1];
  }

  getNewInteraction(event: any) {
    this.clientInteractions$.next([...this.clientInteractions$.value, event]);
    this.cd.detectChanges();
  }

  hasRecentIncomingWhatsApp(interactions: ClientInteraction[]) {
    try {
      if (!interactions || interactions.length === 0) {
        this.showDotColor = 'text-red-500';
        return;
      }
      const currentTime = new Date();

      interactions = interactions.filter(interaction => interaction.interaction_type?.toLowerCase() == 'whatsapp' && (interaction.direction == CommunicationDirection.Incoming || interaction.direction.toString() == CommunicationDirection[CommunicationDirection.Incoming]));

      var isActive = interactions.some(interaction => {
        // Get interaction time and calculate difference
        const interactionTime = this.timeService.ConvertUTCToLocalDateTime(interaction.log_date);
        const hoursDifference = (currentTime.getTime() - interactionTime.getTime()) / (1000 * 60 * 60);
        return hoursDifference < 24;

      });
      if(isActive) this.showDotColor = 'text-green-500';
      else this.showDotColor = 'text-red-500';

    } catch (error) {
      console.error('Error checking for recent incoming WhatsApp:', error);
    }

  }


  getInteractionDetails(interaction: any) {
    let interactionObj = null;
    switch (interaction.interaction_type.toLowerCase()) {
      case 'email':
        interactionObj = this.interactionDetails.find(
          (e) =>
            e.type === 'email' &&
            (interaction.direction
              ? interaction.direction.toLowerCase() === e.status
              : e.status === 'outgoing')
        );
        break;
      case 'sms':
        {
          interactionObj = this.interactionDetails.find(
            (s) =>
              s.type == 'sms' &&
              (interaction.direction
                ? interaction.direction.toLowerCase() == s.status
                : s.status == 'outgoing')
          );
        }
        break;
      case 'notification':
        interactionObj = this.interactionDetails.find(
          (e) => e.type == interaction.interaction_type.toLowerCase()
        );
        break;
      case 'tour':
        interactionObj = this.interactionDetails.find(
          (e) => e.type == interaction.interaction_type.toLowerCase()
        );
        break;
      case 'call':
        interactionObj = this.interactionDetails.find(
          (e) => e.type == interaction.interaction_type.toLowerCase()
        );
        break;
    }
    return interactionObj;
  }


  filterInteractions() {
    this.getClientInteractions();
  }

  get getAllParams(): Array<any> {
    return [...this.requestParams.values()];
  }

  get selectedTenant(): UntypedFormControl {
    return this.filterForm.controls.selectedTenant as UntypedFormControl;
  }

  getCallOutcome(outcome: any) {
    if (outcome.toLowerCase() == 'noanswer_leftmessage')
      return this.callOutcome.find((c) => c.shortname == 'noanswer');
    if (outcome.toLowerCase() == 'notinterested')
      return this.callOutcome.find((c) => c.shortname == 'notintrested');
    else
      return this.callOutcome.find(
        (c) => c.shortname.toLowerCase() == outcome.toLowerCase()
      );
  }

  getTourOutcome(outcome: any) {
    if (outcome.toLowerCase() == 'notinterested')
      return this.callOutcome.find((c) => c.shortname == 'notintrested');
    return this.tourOutcome.find(
      (c) => c.shortname.toLowerCase() == outcome.toLowerCase()
    );
  }

  resetFilter() {
    this.typeFilterArray.clear();
    this.requestParams.clear();
    this.filterForm.controls.selectedTasks.setValue([]);
    this.filterForm.controls.selectAllTask.setValue(false);
    this.getClientInteractions();
  }

  getFilterData() {
    this.requestParams.clear();
    this.typeFilterArray.clear();
    if (
      this.filterForm.controls.fromDate.value &&
      this.filterForm.controls.toDate.value
    ) {
      this.requestParams.set('from_date', {
        paramName: 'from_date',
        paramValue: this.formatFromDate(
          new Date(this.filterForm.controls.fromDate.value)
        ),
      });
      this.requestParams.set('to_date', {
        paramName: 'to_date',
        paramValue: this.formatToDate(
          new Date(this.filterForm.controls.toDate.value)
        ),
      });
    }
    if (this.filterForm.controls.selectedTasks.value.length > 0)
      this.filterForm.controls.selectedTasks.value.forEach((elm: any) => {
        this.typeFilterArray.set(elm, {
          paramName: 'interaction_types',
          paramValue: elm,
        });
      });
    this.getClientInteractions();
  }

  selectAll(event: any) {
    if (event.checked) {
      this.typeFilterArray.clear();
      this.selectedTasks = this.taskTypes;
      this.filterForm.controls.selectedTasks.setValue(this.selectedTasks);
      this.filterForm.controls.selectAllTask.setValue(event.checked);
      this.selectedTasks.forEach((elm: any) => {
        this.typeFilterArray.set(elm, {
          paramName: 'interaction_types',
          paramValue: elm,
        });
      });
    } else {
      this.selectedTasks = [];
      this.typeFilterArray.clear();
      this.filterForm.controls.selectedTasks.setValue(this.selectedTasks);
      this.filterForm.controls.selectAllTask.setValue(event.checked);
    }
  }

  selectAllTask(event: any) {
    if (event.checked) {
      this.typeFilterArray.clear();
      this.selectedTasks = this.taskTypes;
      this.filterForm.controls.selectedTasks.setValue(this.selectedTasks);
      this.selectedTasks.forEach((elm: any) => {
        this.typeFilterArray.set(elm, {
          paramName: 'interaction_types',
          paramValue: elm,
        });
      });
    } else {
      this.selectedTasks = [];
      this.typeFilterArray.clear();
      this.filterForm.controls.selectedTasks.setValue(this.selectedTasks);
    }
  }

  formatFromDate(d: any) {
    const month = d.getMonth() + 1;
    const parseDate = `${d.getFullYear()}-${month > 9 ? month : '0' + month
      }-${d.getDate()}T00:00:00`;
    return parseDate.toString();
  }

  formatToDate(d: any) {
    const month = d.getMonth() + 1;
    const parseDate = `${d.getFullYear()}-${month > 9 ? month : '0' + month
      }-${d.getDate()}T23:59:59`;
    return parseDate.toString();
  }

  toggleOverlay = (event: any) => this.staffDetails.toggle(event);
  show = (event: any) => this.staffDetails.show(event);
  hide = () => this.staffDetails.hide();

  getAttachment(base64: string) {
    var blob = this.base64toBlob(base64, this.detectMimeType(base64));
    var url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

  base64toBlob(b64Data: string, contentType: string) {
    contentType = contentType || '';
    let sliceSize = 512;
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  detectMimeType(b64: string) {
    for (var s in this.signatures) {
      if (b64.indexOf(s) === 0) {
        return this.signatures[s];
      }
    }
  }

  toggleCollapse(value: boolean) {
    this.showCollapsed$.next(value);
    if (value == true) {
      var data = this.clientInteractions$.getValue();
      data.forEach(o => {
        o.showMore = true;
      });
      this.clientInteractions$.next(data);
    }
    else {
      var data = this.clientInteractions$.getValue();
      data.forEach(o => {
        o.showMore = false;
      });
      this.clientInteractions$.next(data);
    }
  }

 emailLastActivity(interaction:ClientInteraction)
 {
  if(interaction.is_click) 
  {
    return {"activity":"CLICKED",date:interaction.click_date}
  }
  else if(interaction.is_open)
  {
    return {"activity":"OPENED",date:interaction.open_date}
  }
  else{
    return {"activity":"",date:interaction.log_date}
  }
 }

  get showSkeleton(): boolean {
    return this.showSkeleton$.value;
  }

  get collapseAll()
  {
    return this.showCollapsed$.value;
  }

  public get directionEnum()
  {
    return CommunicationDirection;
  }

  ngOnDestroy(): void {
    // Don't unsubscribe from input BehaviorSubjects as they are controlled by parent
    // this.showSkeleton$.unsubscribe();
    // this.showCollapsed$.unsubscribe();
    // this.clickfromTab.unsubscribe();
    // Only unsubscribe from BehaviorSubjects created inside this component
    if (this.clientInteractions$) {
      this.clientInteractions$.complete();
    }
    if (this.allInteractions$) {
      this.allInteractions$.complete();
    }
    
    this.filterForm.reset();
    this.requestParams.clear();
    this.typeFilterArray.clear();
    this.selectedTasks = [];
    if (this.filterForm.controls.selectedTenant) {
      this.filterForm.controls.selectedTenant.setValue(null);
    }
    if (this.filterForm.controls.selectedTasks) {
      this.filterForm.controls.selectedTasks.setValue(this.selectedTasks);
    }
    if (this.filterForm.controls.selectAllTask) {
      this.filterForm.controls.selectAllTask.setValue(false);
    }
    this.filterForm.reset();
    
    // Check if the observables exist before unsubscribing
    if (this.getStaffList$ && typeof this.getStaffList$.unsubscribe === 'function') {
      this.getStaffList$.unsubscribe();
    }
    
    if (this.getAccessTenantList$ && typeof this.getAccessTenantList$.unsubscribe === 'function') {
      this.getAccessTenantList$.unsubscribe();
    }
  }

}
